import { CustomNotificationType, NotificationType, OnboardingNotificationTypes } from '../enums';
import { AppRoutes, GamesRoutes, HostedGamesRoutes, NotificationsRoutes, TeamsRoutes } from '@core';
import { NotificationRedirect } from '../interfaces/notification-redirect.model';
import { actionPushComponentsMapper } from '../mappers/action-push-components.mapper';
import { Observable } from 'rxjs';

export const notificationRedirectUtil = (data: NotificationRedirect): Promise<boolean> | void | Observable<unknown> => {
  const hostedGames: NotificationType[] = [
    NotificationType.HostedGameNewApplication,
    NotificationType.HostedGamePlayerLeft,
    NotificationType.HostedGameReminder,
    NotificationType.HostedGamePlayerAutoApproved
  ];
  const playerGames: NotificationType[] = [
    NotificationType.GameApplicationApproved,
    NotificationType.GameReminder,
    NotificationType.GameCanceled,
    NotificationType.GameUpdated
  ];

  const sharedGames: NotificationType[] = [NotificationType.NewGameByAlert, NotificationType.GameInvitationRecived];

  const profile: NotificationType[] = [
    NotificationType.UserPenaltyReceived,
    NotificationType.NewTrophyReceived,
    NotificationType.NewCommentReceived
  ];

  if (hostedGames.includes(data.type)) {
    return data.router.navigate([`${AppRoutes.HOST}/${HostedGamesRoutes.FUTURE}/${data.gameId}`]);
  }

  if (playerGames.includes(data.type)) {
    return data.router.navigate([`${AppRoutes.GAMES}/${GamesRoutes.DETAILS}/${data.gameId}`]);
  }

  if (sharedGames.includes(data.type)) {
    return data.router.navigate([`${AppRoutes.GAMES}/${GamesRoutes.SHARED}/${data.gameId}`]);
  }

  if (data.type === NotificationType.GameFinished || data.type === NotificationType.HostedGameFinished) {
    return data.router.navigate([`${AppRoutes.GAMES}/${GamesRoutes.GAME_FINISHED}/${data.gameId}`]);
  }

  if (profile.includes(data.type)) {
    return data.router.navigate([`${AppRoutes.PROFILE}/${data.receiverUserId}`]);
  }

  if (data.type === NotificationType.ChatNewMessage) {
    return data.router.navigate([AppRoutes.MESSAGES]);
  }

  if (data.type === NotificationType.CustomNotification) {
    return handleCustomNotificationRedirect(data);
  }

  if (data.type === NotificationType.TeamMemberAddedByHost) {
    return data.router.navigate([`${AppRoutes.TEAMS}/${data.teamId}/${TeamsRoutes.TEAM_DETAILS}`]);
  }

  if (data.type === NotificationType.GameLineupsCreated) {
    return data.router.navigate([`${AppRoutes.GAMES}/${GamesRoutes.LINEUPS}/${data.gameId}`]);
  }

  if (OnboardingNotificationTypes.includes(data.type)) {
    return handleActionPushNotification(data);
  }

  return data.router.navigate([AppRoutes.NOTIFICATIONS]);
};

const handleActionPushNotification = (data: NotificationRedirect): Promise<boolean> | Observable<unknown> => {
  if (
    data.type === NotificationType.ActionPushPlayerInactive ||
    data.type === NotificationType.ActionPushPlayerInactive2
  )
    return data.router.navigateByUrl(`${AppRoutes.FIND_GAMES}`);

  if (data.type === NotificationType.ActionPushHostInactive) {
    return data.router.navigateByUrl(`${AppRoutes.HOST}/${HostedGamesRoutes.CREATE_GAME}`);
  }

  return data.modalProvider.showModal$({
    component: actionPushComponentsMapper[data.type],
    componentProps: { gameId: data.gameId },
    cssClass: 'present-modal'
  });
};

const handleCustomNotificationRedirect = (data: NotificationRedirect): Promise<boolean> | void => {
  if (data.customType === CustomNotificationType.Page) {
    return data.router.navigate([
      `${AppRoutes.NOTIFICATIONS}/${NotificationsRoutes.CUSTOM_NOTIFICATION}/${data.customId}`
    ]);
  }

  if (data.customType === CustomNotificationType.Redirect) {
    return data.router.navigateByUrl(data.customRedirectUrl);
  }

  if (data.customType === CustomNotificationType.Modal) {
    return data.router.navigateByUrl(data.customRedirectUrl);
  }

  return data.onCustomModalOpen();
};
